import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { SalesCreditNote } from '../model/sales-credit-note.model';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SalesCreditNoteState<T extends SalesCreditNote> extends EntityState<T> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'sales-credit-notes', idKey: 'lngOrderID', resettable: true })
export class SalesCreditNoteStore<T extends SalesCreditNote> extends EntityStore<SalesCreditNoteState<T>> {
  constructor() {
    super();
  }
}
